
import { computed, defineComponent, ref, PropType } from 'vue'
import {
  DropdownVariantsMap,
  DropdownVariantsEnum,
  DropdownVariantsArray,
} from './BDropdown.types'

export default defineComponent({
  name: "BDropdown",
  props: {
    variants: {
      type: String as PropType<DropdownVariantsEnum>,
      required: false,
      default: DropdownVariantsEnum.PRIMARY,
      validator: (prop: DropdownVariantsEnum) => DropdownVariantsArray.includes(prop)
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const dropdownPopoverShow = ref(false)
    const classes = computed(() => DropdownVariantsMap[props.variants])

    function toggleDropdown() {
      dropdownPopoverShow.value = !dropdownPopoverShow.value
      emit('toggleDropdown', dropdownPopoverShow.value)
    }

    return {
      toggleDropdown,
      dropdownPopoverShow,
      classes,
    }
  }

})
